// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trigger-payrun-container {
  max-width: 500px;
  margin: 40px auto;
  padding: 24px;
  border: 1px solid #ccc;
  border-radius: 12px;
  background-color: #f9f9f9;
}

.form-group {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

label {
  margin-bottom: 4px;
  font-weight: 600;
}

select,
input {
  padding: 8px;
  font-size: 1rem;
}

.trigger-button {
  background-color: #007bff;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.trigger-button:hover {
  background-color: #0056b3;
}

.error-message{
  background-color: 'red';
  color:'red'
}
`, "",{"version":3,"sources":["webpack://./src/components/xero/TimesheetExport.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB;AACF","sourcesContent":[".trigger-payrun-container {\n  max-width: 500px;\n  margin: 40px auto;\n  padding: 24px;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  background-color: #f9f9f9;\n}\n\n.form-group {\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\nlabel {\n  margin-bottom: 4px;\n  font-weight: 600;\n}\n\nselect,\ninput {\n  padding: 8px;\n  font-size: 1rem;\n}\n\n.trigger-button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.trigger-button:hover {\n  background-color: #0056b3;\n}\n\n.error-message{\n  background-color: 'red';\n  color:'red'\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
